(function(module) {
    'use strict';

    function BlockedAccountCtrl(Store, LoopBackAuth, $state) {
        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);

            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');
        };
    }

    function BlockedAccountConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('root.blocked-account', {
                url: '/blocked-account',
                data: {
                    pageTitle: 'BLOCKED_ACCOUNT.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        templateUrl: '/js/authentication/blocked-account/blocked-account.html',
                        controller: 'BlockedAccountCtrl as $ctrl',
                    },
                },
                resolve: {
                    currentUser: function(User) {
                        return User.getCurrent().$promise.then(function(response) {
                            return response;
                        });
                    },
                    account: function(currentUser, Account, $state) {
                        const accountId = currentUser.accountId;
                        Account.findById({ id: accountId })
                            .$promise
                            .then(function(account) {
                                if (account.enabled && !account.accountVerified) {
                                    $state.go('unverified-account');
                                }

                                if (account.enabled && account.accountVerified) {
                                    $state.go('root.home');
                                }
                            });
                    },
                },
                bodyClass: 'page--blocked-account',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/blocked-account');

    }

    module
        .config(BlockedAccountConfig)
        .controller('BlockedAccountCtrl', BlockedAccountCtrl);

})
(angular.module('rocket.components'));
